import * as React from "react";
import Svg, { Circle, G, Path, Defs, ClipPath } from "react-native-svg";

function SvgComponent(props) {
  const width = props.width || 34;
  const height = props.height || 34;
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Circle cx={17} cy={17} r={16.25} fill="#2ECC4B" />
      <G clipPath="url(#clip0_8527_11620)">
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.052 9.907A9.847 9.847 0 0017.042 7c-5.463 0-9.909 4.445-9.911 9.91-.001 1.747.456 3.452 1.323 4.955L7.047 27l5.254-1.378a9.9 9.9 0 004.736 1.206h.004c5.461 0 9.908-4.445 9.91-9.91a9.847 9.847 0 00-2.899-7.011zm-7.01 15.247h-.004a8.216 8.216 0 01-4.192-1.148l-.301-.178-3.118.817.833-3.04-.196-.312a8.212 8.212 0 01-1.26-4.383c.003-4.542 3.698-8.237 8.242-8.237 2.2 0 4.268.859 5.823 2.415a8.189 8.189 0 012.41 5.828c-.003 4.543-3.698 8.238-8.238 8.238zm4.518-6.169c-.248-.124-1.465-.723-1.693-.806-.226-.082-.391-.124-.557.123-.166.248-.64.806-.784.972-.145.165-.29.186-.537.062-.248-.124-1.046-.385-1.992-1.23-.736-.656-1.233-1.467-1.377-1.715-.144-.248-.015-.382.108-.505.112-.111.248-.29.372-.434.125-.144.166-.247.249-.413.082-.165.042-.31-.02-.434-.063-.123-.558-1.343-.764-1.838-.201-.484-.405-.418-.558-.425a9.537 9.537 0 00-.475-.009.907.907 0 00-.66.31c-.226.249-.866.848-.866 2.066 0 1.22.887 2.397 1.01 2.562.124.165 1.746 2.666 4.23 3.739.591.255 1.053.407 1.412.522.593.188 1.133.161 1.56.098.476-.07 1.465-.6 1.672-1.177.206-.579.206-1.075.144-1.178-.062-.104-.227-.166-.474-.29z"
          fill="#fff"
        />
      </G>
      <Defs>
        <ClipPath id="clip0_8527_11620">
          <Path fill="#fff" transform="translate(7 7)" d="M0 0H20V20H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  );
}

export default SvgComponent;
